module.exports = __webpack_public_path__ + "static/media/language.cd2e155f.webp";